import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  presets: {
    size: {
      width: 123,
      height: 152
    },
    transformations: {
      alignFill: 'center',
      unSharpMask: 100
    }
  }
} satisfies RecursivePartial<CheckoutConfig['orderItem']>
